// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"80ef7ae5","239":"5cfdc5a8","455":"350c443a"}[chunkId] + ".chunk.js";
};